module.exports = __webpack_public_path__ + "assets/img/walking.8f61c5d4.svg";